var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return (_vm.plan.selectFeatures || []).length > 0
    ? _c(
        "div",
        { staticClass: "card-select-feature" },
        [
          _c(
            "a-select",
            {
              attrs: { value: _vm.selectedFeatureIndex },
              on: { change: _vm.onSelectedFeature },
            },
            _vm._l(_vm.plan.selectFeatures, function (selectFeature, index) {
              return _c(
                "a-select-option",
                { key: index, attrs: { value: index } },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.getOptionText(selectFeature.count)) +
                      "\n        "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }